module.exports = __webpack_public_path__ + "img/icon_new_red.f3bd439a.svg";